var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rotateLogo"},[_c('img',{staticClass:"rotating",attrs:{"src":require("../assets/favicon.png"),"alt":"missing"}})])}]

export { render, staticRenderFns }